import ElFormItem from './FormItem.vue'

/* istanbul ignore next */
ElFormItem.install = function (app) {
  app.component(ElFormItem.name, ElFormItem)
}

export default ElFormItem
